<template>
  <div v-if="currentBetSlipState<=1 || parlayStake || singlesStakes.length">

    <div class="PARLAY" v-if="brandTemplate === 'generic_2' && tab==='REGULAR'" v-show="!(currentBetSlipState==5 && betSlipStatus.State==2)">
      <div v-if="activeSelectionsNo>1 && allowedBetTypesAndReturnsA">
        <bet-type-parlay v-if="currentBetSlipState<=1 || parlayStake"
                         :key="'A'"
                         :id="'A'"
                         :currentBetSlipState="currentBetSlipState"
                         :tab="tab"
                         :allowedBetTypesAndReturns="allowedBetTypesAndReturnsA"
                         :gettingABTnR="gettingABTnR"
        ></bet-type-parlay>
      </div>

      <div v-if="activeSelectionsNo>1 && showParlayInfoMsg && currentBetSlipState<=1 && !allowedBetTypesAndReturnsA && (!isSGMenabled || (isSGMenabled && !hasSGM))">
        <div class="msg info all_corners NoParlayAvailable"
             :class="{'interRelated':hasActiveInteRelated, 'NotAllSelectionsCombinableInParlay':!allSelectionsCombinableInParlay}" >
          <v-icon>info_outline</v-icon>
          <span v-if="hasActiveInteRelated && allSelectionsCombinableInParlay">{{ $t('BetSlip.tab.PARLAY.info.interRelated') }}</span>
          <span v-else>{{ $t('BetSlip.tab.PARLAY.info.notAvailable') }}</span>
        </div>
      </div>
    </div>

    <v-expansion-panel class="stakeAll_holder" v-if="wagerAllSingles" v-show="tab==='REGULAR' && betsNo>1 && currentBetSlipState<1">
      <v-expansion-panel-content>
        <template v-slot:header>
          <span>
            {{$t('BetSlip.single.wagerAllStraights')}}
          </span>
        </template>
        <div class="stakeAll">
        <money-input v-model="multiSinglesStake"
          :id="1"
          :placeholder="''"
          :disabled="currentBetSlipState>=1"
          :focus="focus"
          @setFocus="setFocus"
          @dismissError="dismissError"
        ></money-input>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <div class="tab-btns" v-if="!currentBetSlipState && tab=='REGULAR'">
      <button v-if="hasAvailableTeasers" @click="setTab('TEASER')" class="btn secondary btn_blue" >
        <span>{{ $t('BetSlip.tab.TEASERS') }}</span> <span class="arrow-right"></span>
      </button>
      <button v-if="!currentBetSlipState && tab=='REGULAR' && hasAllowedBetTypesRR" @click="setTab('RR')" class="btn secondary btn_blue" >
        <span>{{ $t('BetSlip.tab.RRS') }}</span> <span class="arrow-right"></span>
      </button>
    </div>
  </div>
</template>

<script>
  //  import Vue from 'vue'
  import store from '@/store'
  import Vue from 'vue'
  import moneyInput from '../common/moneyInput'
  import betTypeParlay from '../betTypes/betTypeParlay.vue'
  import Branding from '@/components/mixins/Branding'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'tabsBetslipBottom',

    mixins: [
      Branding
    ],

    props: ['tab', 'currentBetSlipState', 'betsNo', 'allowedBetTypesAndReturns', 'betTypeStakes', 'allowedMultiSingles'],

    components: {
      moneyInput,
      betTypeParlay,
      Icon
    },

    data () {
      return {
        focus: [0],
        showParlayInfoMsg: false
      }
    },

    computed: {
      betslipLayout2 () {
        return window.ctsautoconf.BETSLIP_LAYOT_2 || false
      },
      useSelectionTeaserInfos () {
        return store.getters['sbBetslipState/useSelectionTeaserInfos']
      },
      teaserSelectionGroups () {
        return this.useSelectionTeaserInfos ? store.getters['sbBetslipState/teaserSelectionGroups'] : []
      },
      teasers () {
        return store.getters['sbBetslipState/teasers']
      },
      teaserGroups () {
        return this.useSelectionTeaserInfos ? this.teaserSelectionGroups : this.teasers && this.teasers.teaserGroups
      },
      hasAvailableTeasers () {
        let has = false
        if (this.teaserGroups && this.teaserGroups.length) {
          for (let g in this.teaserGroups) {
            let group = this.teaserGroups[g]
            if (group.Selections && group.Selections.length > 1) {
              has = group.Selections.length
              break
            }
          }
        }
        return !!has
      },
      hasAllowedBetTypesRR () {
        // let allowedBetTypes = this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.RR && this.allowedBetTypesAndReturns.RR.AllowedBetTypes
        let allowedBetTypes = this.allowedBetTypesAndReturns && this.allowedBetTypesAndReturns.REGULAR && this.allowedBetTypesAndReturns.REGULAR.AllowedBetTypes
        allowedBetTypes = allowedBetTypes || []
        let rrBetTypes = allowedBetTypes.filter(function (bT) {
          return bT.IDFOBetType !== 'S' && bT.IDFOBetType[0] === 'C' && bT.BetTypeInstruction !== 'A'
        })
        return !!rrBetTypes.length
      },
      wagerAllSingles () {
        return store.getters['sbBetslipState/wagerAllSingles']
      },
      parlayStake () {
        return this.allowedBetTypesAndReturnsA &&
          this.betTypeStakes && this.betTypeStakes.REGULAR && this.betTypeStakes.REGULAR.PerBetType && this.betTypeStakes.REGULAR.PerBetType.A
      },
      singlesStakes () {
        var singlesStakes = []
        if (this.betTypeStakes && this.betTypeStakes.REGULAR && this.betTypeStakes.REGULAR.PerSelection) {
          for (var i in this.betTypeStakes.REGULAR.PerSelection) {
            if (this.betTypeStakes.REGULAR.PerSelection[i]) {
              singlesStakes.push(this.betTypeStakes.REGULAR.PerSelection[i])
            }
          }
        }
        return singlesStakes
      },
      multiSinglesStake: {
        get: function () {
          return store.getters['sbBetslipState/multiSinglesStake']
        },
        set: function (newVal) {
          // console.log('multiSinglesStake newVal: ' + newVal)
          store.commit('sbBetslipState/setMultiSinglesStake', newVal)
          this.updateSinglesStake(newVal)
        }
      },
      betSlipStatus () {
        return store.getters['sbBetslipState/betSlipStatus']
      },
      gettingABTnR () {
        return store.getters['sbBetslipState/gettingABTnR']
      },
      optedIn () {
        return store.getters['sbBetslipState/optedIn'][this.tab]
      },
      activeSelectionsNo () {
        var c = 0
        for (var i in this.optedIn) {
          c += this.optedIn[i] ? 1 : 0
        }
        return c
      },
      allowedBetTypesAndReturnsXP () {
        return this.allowedBetTypesAndReturns &&
          this.allowedBetTypesAndReturns.XP
      },
      allowedBetTypesAndReturnsA () {
        return this.allowedBetTypesAndReturns &&
          this.allowedBetTypesAndReturns.REGULAR &&
          this.allowedBetTypesAndReturns.REGULAR.PotentialReturns &&
          this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType &&
          this.allowedBetTypesAndReturns.REGULAR.PotentialReturns.PerBetType.A
      },
      isSGMenabled () {
        return store.getters['sbBetslipState/isSGMenabled']
      },
      hasSGM () {
        // console.log('hasSGM')
        if (!this.isSGMenabled) {
          return false
        }
        let cnt = 0
        if (this.allowedBetTypesAndReturnsXP && this.allowedBetTypesAndReturnsXP.PerEvent) {
          for (var e in this.allowedBetTypesAndReturnsXP.PerEvent) {
            var event = this.allowedBetTypesAndReturnsXP.PerEvent[e]
            var l = event && event.Legs ? event.Legs.length : 0
            cnt = l > cnt ? l : cnt
          }
        }
        return !!cnt
      },
      interRelatedPerTab () {
        return store.getters['sbBetslipState/interRelatedPerTab'](this.tab)
      },
      hasActiveInteRelated () {
        return Object.keys(this.interRelatedPerTab).length > 0
      },
      allSelectionsCombinableInParlay () {
        var selections = store.getters['sbBetslipState/getSelections4Calculation'](this.tab) || []
        var allIn = selections.every(function (selection) {
          let betTypes = selection.csvavailablebettypes || selection.bettypecsv || []
          return betTypes.includes('A')
//          return betTypes.length === 0 || betTypes.includes('A')
        })
        return allIn
      }
    },

    methods: {
      setFocus (id, val) {
//        console.log('setFocus: ' + id + '; val: ' + val)
        if (val) {
          Vue.set(this.focus, 0, id)
        } else {
          if (this.focus[0] === id) {
            Vue.set(this.focus, 0, 0)
          }
        }
      },
      dismissError (id, hasError) {
        store.commit('sbBetslipState/dismissErrorFromSelection', hasError)
      },
      updateSinglesStake (v) {
        var multiSinglesStake = v || this.multiSinglesStake
        if (!multiSinglesStake || parseFloat(multiSinglesStake) <= 0) {
          multiSinglesStake = ''
        }
        for (var s in this.allowedBetTypesAndReturns.PerSelection) {
          var sourceId = store.getters['sbBetslipState/getSourceIdForDerivedSelection'](s)
          Vue.set(this.betTypeStakes.PerSelection, sourceId || s, multiSinglesStake)
        }
      },
      setTab (tab) {
        if (this.currentBetSlipState) {
          return
        }
        store.commit('sbBetslipState/setTab', tab)
  //        this.dismissBetSlip(null, !true)
      }
    },

    created () {
    },

    mounted () {
    },

    watch: {
      gettingABTnR: {
        immediate: true,
        handler (newVal, oldVal) {
          var self = this
          if (newVal) {
            this.showParlayInfoMsg = false
          } else {
            if (this.betsNo > 1) {
              setTimeout(function () {
                self.showParlayInfoMsg = true
              }, 300)
            } else {
              self.showParlayInfoMsg = false
            }
          }
        }
      }
    },

    destroyed () {
    }
  }
</script>

<style lang="stylus" scoped>
  // @import "~@/css/config"

</style>



// WEBPACK FOOTER //
// src/components/sports/betslipV2/rootElements/tabsBetslipBottom.vue